// Search Bar
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll(`form[role="search"] input[type="search"]`).forEach(input => {
    input.addEventListener('click', function() {
      this.parentElement.querySelector('.predictive-search').setAttribute('open', '');
    });
  });

  window.addEventListener('click', function(e) {
    // if search open and the click is at outside
    if (document.querySelector('.predictive-search[open]') && !e.target.closest('.predictive-search') && !e.target.closest('.boolland-search-wrap')) {
      e.preventDefault();
      document.querySelectorAll('.predictive-search')?.forEach(el => el.removeAttribute('open'));
    }
  });

  const trendingButtons = document.querySelectorAll('.predictive-search .bl-trending-searches span.button');
  trendingButtons.forEach(el => {
    el.addEventListener('click', function() {
      const form = this.closest(`form[role="search"]`);
      const input = form.querySelector('input[type="search"]');
      const button = form.querySelector('button[type="submit"]');
      
      input.value = this.textContent;
      button.click();
    });
  });
});